import { orderSliceActions } from 'app/pages/order/redux/order-slice';
import type { AppDispatch, AppState } from 'app/redux/types/types';
import { pushSelectSingleUnitToCartEvent } from 'app/data-layers/events/push-select-single-unit-to-cart-event';
import { selectPartner, selectShoppingCartOrThrow } from 'app/pages/order/redux/order-selector';
import { pushAddToCartSingleUnitEvent } from 'app/data-layers/events/push-add-to-cart-single-unit-event';

export const changeIsPurchasingSingleUnitActionCreator =
    (isPurchasingSingleUnit: boolean) => (dispatch: AppDispatch, getState: () => AppState) => {
        const rootState = getState();
        const shoppingCart = selectShoppingCartOrThrow(rootState);
        const partner = selectPartner(rootState);

        dispatch(orderSliceActions.changeIsPurchasingSingleUnit(isPurchasingSingleUnit));

        if (isPurchasingSingleUnit) {
            pushSelectSingleUnitToCartEvent(shoppingCart, partner);
            pushAddToCartSingleUnitEvent(shoppingCart, partner);
        }
    };
